import React from "react";
import { Image, StyleSheet, TouchableOpacity, View, Linking } from "react-native";
import analytics from "@services/analytics";
import { width } from "@constants/metrics";

interface BannerProps {
    item: {
        id: string;
        title?: string;
        subtitle?: string;
        type?: string;
        loading?: string[];
        banners: [
            {
                image_url: string;
                nav_to?: string;
                nav_params?: any;
                image_dimension_width?: number;
                image_dimension_height?: number;
            }
        ]
    };
}

const Banner: React.FC<BannerProps> = React.memo(({ item }) => {
    const widthMinusPadding = width - 32;

    const handleBannerPress = (banner: any) => {
        if (banner?.nav_to) {
            analytics.trackEvent(`${item?.type || 'Banner'} Clicked`, {
                source: "Home Page Widget",
                banner_id: item?.id,
            });

            banner.nav_to && Linking.openURL(banner.nav_to);
        }
    };

    const renderBanner = (banner: any, index: number) => {
        const aspectRatio = banner?.image_dimension_width && banner?.image_dimension_height 
            ? banner.image_dimension_width / banner.image_dimension_height 
            : 3;
        const imageHeight = widthMinusPadding / aspectRatio;

        return (
            <TouchableOpacity
                key={`${item.id}-banner-${index}`}
                activeOpacity={0.8}
                disabled={!banner?.nav_to}
                onPress={() => handleBannerPress(banner)}
                style={styles.bannerTouchable}
            >
                <Image
                    source={{ uri: banner.image_url }}
                    style={[styles.bannerImage, { height: imageHeight }]}
                    resizeMode="contain"
                />
            </TouchableOpacity>
        );
    };

    return (
        <View
            testID="hpw-banner"
            style={[
                styles.container,
            ]}
        >
            {item?.banners && item.banners.length > 0 ? (
                <View style={styles.verticalImagesContainer}>
                    {item.banners.map((banner, index) => renderBanner(banner, index))}
                </View>
            ) : null}
        </View>
    );
});

export default Banner;

const styles = StyleSheet.create({
    container: {
        width: width - 32,
        marginHorizontal: 6,
        overflow: "hidden",
        marginVertical: 6,
    },
    verticalImagesContainer: {
        width: "100%",
        flexDirection: "column",
    },
    bannerTouchable: {
        width: "100%",
        borderRadius: 8,
        marginBottom: 10,
    },
    bannerImage: {
        width: "100%",
        borderRadius: 8,
    }
});
